// Main entry point — imports SCSS and all JS parts
import '../sass/styles.scss';

// Site-wide modules (always loaded)
import footerLinks from './parts/footer-links';
import urlClean from './parts/url';

// Page-specific modules (lazy-loaded only when their selectors exist on the page)
const lazyParts = {
  '.updater-qualform-form':  () => import(/* webpackChunkName: "qual-form-hotfix" */     './parts/qual-form-hotfix'),
  '.gauge-cont':             () => import(/* webpackChunkName: "speed-guage" */          './parts/speed-guage'),
};

// Initialize on DOM ready
jQuery(function ($) {
  // Run site-wide modules
  footerLinks($);
  urlClean($);

  // Selectors whose chunks should wait until the user scrolls (heavy libs
  // that are in the initial viewport but not needed for LCP).
  var deferUntilScroll = new Set(['#growthImageMobile-1', '.growth-tab']);

  // Lazy-load page-specific modules only when their selectors exist
  Object.entries(lazyParts).forEach(function ([selector, loader]) {
    if (!document.querySelector(selector)) return;

    if (deferUntilScroll.has(selector)) {
      // Defer import until the user actually scrolls so the chunk
      // doesn't compete with LCP on first paint.
      window.addEventListener('scroll', function () {
        loader().then(function (mod) { mod.default($); });
      }, { once: true, passive: true });
    } else {
      loader().then(function (mod) { mod.default($); });
    }
  });
});
